/* tslint:disable */
/* eslint-disable */
/**
 * esign
 * eSign template authoring and request management service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CompletedDocumentLinkStatus = {
    Active: 'active',
    Expired: 'expired',
    Revoked: 'revoked',
} as const;
export type CompletedDocumentLinkStatus = typeof CompletedDocumentLinkStatus[keyof typeof CompletedDocumentLinkStatus];


export function instanceOfCompletedDocumentLinkStatus(value: any): boolean {
    for (const key in CompletedDocumentLinkStatus) {
        if (Object.prototype.hasOwnProperty.call(CompletedDocumentLinkStatus, key)) {
            if (CompletedDocumentLinkStatus[key as keyof typeof CompletedDocumentLinkStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CompletedDocumentLinkStatusFromJSON(json: any): CompletedDocumentLinkStatus {
    return CompletedDocumentLinkStatusFromJSONTyped(json, false);
}

export function CompletedDocumentLinkStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompletedDocumentLinkStatus {
    return json as CompletedDocumentLinkStatus;
}

export function CompletedDocumentLinkStatusToJSON(value?: CompletedDocumentLinkStatus | null): any {
    return value as any;
}

export function CompletedDocumentLinkStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): CompletedDocumentLinkStatus {
    return value as CompletedDocumentLinkStatus;
}

